import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/** Placeholder while `GET …/dashboard/pipeline-counts` loads — avoids list-subset count flash. */
export function PipelineStatusGridSkeleton() {
  return (
    <section className="space-y-3 min-w-0" aria-busy="true" aria-label="Loading pipeline status">
      <Skeleton className="h-4 w-48" />
      <Card className="border-border/50 min-w-0">
        <CardContent className="pt-4 space-y-3">
          <Skeleton className="h-3 w-full max-w-md" />
          <Skeleton className="h-9 w-full" />
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="h-16 w-full rounded-lg" />
            ))}
          </div>
        </CardContent>
      </Card>
    </section>
  );
}
